import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { PageShell } from "@/components/marketing/PageShell";
import { api, formatApiError } from "@/lib/api";

export default function VerifyEmail() {
  const { token } = useParams();
  const [state, setState] = useState({ phase: "loading" });
  useEffect(() => {
    api.post("/signup/verify-email", { token })
      .then(() => setState({ phase: "ok" }))
      .catch((e) => setState({ phase: "error", msg: formatApiError(e) }));
  }, [token]);
  return (
    <PageShell eyebrow="— ACCOUNT —">
      <div className="mx-auto max-w-lg rounded-3xl border border-gray-200 bg-white p-10 text-center" data-testid={`verify-email-${state.phase}`}>
        {state.phase === "loading" && <Loader2 className="mx-auto h-8 w-8 animate-spin text-oath-muted" />}
        {state.phase === "ok" && <><CheckCircle2 className="mx-auto h-10 w-10 text-emerald-600" /><h1 className="mt-4 font-display text-2xl font-bold">Email confirmed</h1><p className="mt-2 text-sm text-oath-secondary">You can now see verification requests about you.</p></>}
        {state.phase === "error" && <><XCircle className="mx-auto h-10 w-10 text-oath-muted" /><p className="mt-4 text-sm text-oath-secondary">{state.msg}</p></>}
        <Link to="/signin" className="mt-6 inline-block text-sm text-oath-accent underline" data-testid="verify-email-signin">Sign in</Link>
      </div>
    </PageShell>
  );
}
